import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Fragment, useState } from 'react';

const ConfirmationDialog = ({open, handleClose, saveData, dialogData, isSRNumberRequired=false}) => {
    const [srNumber, setSrNumber] = useState('');
    const [showError, setShowError] = useState(false);

    const handleSRNumberChange = (event) =>{
        if (showError) {
            setShowError(false); // Hide error when user starts typing
        }
        const srNumber = event.target.value;
        setSrNumber(srNumber);
    }

    const handleSaveData = () => {
        if (!srNumber.trim()) {
            setShowError(true);
            return;
        }
        saveData(srNumber);
        setSrNumber(''); // Reset SR number after saving
    };

    return (
        <Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {dialogData?.dialogTitle}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      <span dangerouslySetInnerHTML={{__html: dialogData?.dialogText}}></span>  <br/><br/>

                      {isSRNumberRequired && <> Please enter SR number <span style={{color:'red'}}>*</span>: <br/>
                       <input type="text" style={{padding: '0.5rem',  width: '80%', borderRadius: '4px', border:"1px solid"}} onChange={handleSRNumberChange} /> <br/>
                      { showError && <span style={{color:'red', fontSize: 'small'}} >SR Number is required</span> }
                    </>}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" onClick={isSRNumberRequired ? handleSaveData : saveData}>{dialogData?.submitButtonText}</Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
};

export default ConfirmationDialog;
